import { Injectable, inject } from '@angular/core';

import { differenceInCalendarDays, parseISO } from 'date-fns';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DataService } from '../../shared/services/data.service';
import { ProductUpdate } from '../models/product-update.model';

interface ProductUpdateResponse {
  summary: string;
  content: string;
  date: string;
  preview: string;
}

@Injectable({ providedIn: 'root' })
export class ProductUpdateService {
  private readonly apiService = inject(DataService);

  public getAll(): Observable<ProductUpdate[]> {
    return this.apiService
      .getApp<{ productUpdates: ProductUpdateResponse[] }>('product-updates.json')
      .pipe(
        map((res) => res.productUpdates),
        map((res) =>
          res.map(
            (update) =>
              ({
                preview: update.preview,
                summary: update.summary,
                content: update.content,
                isNew: differenceInCalendarDays(new Date(), parseISO(update.date)) <= 15,
                date: update.date,
              }) as ProductUpdate
          )
        )
      );
  }
}
